import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../orpc'

// Scheduled deletion date for the company (any member)
export function useDataRetentionStatus(options?: { enabled?: boolean }) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery({
    ...orpc.dataRetention.status.queryOptions(),
    enabled: options?.enabled ?? true,
  })
}

// Most recent unexpired export (owner). Polls while one is being built.
export function useLatestDataExport(options?: { enabled?: boolean }) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery({
    ...orpc.dataRetention.latestExport.queryOptions(),
    enabled: options?.enabled ?? true,
    refetchInterval: (query) => (query.state.data?.status === 'pending' ? 5000 : false),
  })
}

export function useRequestDataExport() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()
  return useMutation(
    orpc.dataRetention.requestExport.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.dataRetention.latestExport.key() })
      },
    })
  )
}

export function useDataExportDownloadUrl() {
  const orpc = useOrpcTanstackQueryUtils()
  return useMutation(orpc.dataRetention.exportDownloadUrl.mutationOptions())
}

export function useRequestCompanyDeletion() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()
  return useMutation(
    orpc.dataRetention.requestDeletion.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.dataRetention.status.key() })
      },
    })
  )
}

export function useCancelCompanyDeletion() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()
  return useMutation(
    orpc.dataRetention.cancelDeletion.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.dataRetention.status.key() })
      },
    })
  )
}
